import React from 'react';
import Select from '@lwt-helix/select';

const SecurityGroupSelect = ({
  securityGroups,
  setSecurityGroup,
  setIsSecurityGroupValid,
}) => {
  const securityGroupNames = securityGroups.map((obj) => {
    return { value: obj.name, label: obj.name };
  });
  if (
    securityGroupNames[0]?.label === 'System Admin' &&
    securityGroupNames[1]?.label === 'Limited Access'
  ) {
    let temp = securityGroupNames[0];
    securityGroupNames[0] = securityGroupNames[1];
    securityGroupNames[1] = temp;
  }

  const handleSelect = (e) => {
    setSecurityGroup(e);
    setIsSecurityGroupValid(true);
  };
  return (
    <Select
      onChange={handleSelect}
      dataLwtId="security-group-select"
      isSearchable={false}
      isClearable={false}
      options={securityGroupNames}
      placeholder={
        securityGroups.length === 0
          ? 'No Security Groups available'
          : 'Select...'
      }
    />
  );
};

export default SecurityGroupSelect;
